import { useFormikContext } from 'formik';
import React, { useEffect, useMemo } from 'react';

import { IAddAdjustment } from '@modules/ContactManager/components/Tabs/components/Deals/components/Tiles/interfaces';
import { FormPart } from '@modules/shared/components/FormPart';
import { Roles } from '@shared/constants/constants';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { useUserAccount } from '@shared/hooks/useUserAccount';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper } from '@styles/CommonStyles';

export const AdjustmentForm = ({ setOpenAdjustmentModal, loading }: {
  setOpenAdjustmentModal: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
}) => {
  const { values, setFieldValue } = useFormikContext<IAddAdjustment>();
  const { isAdmin, userHasRoles } = useUserAccount();
  const hasAdminAccountingRole = isAdmin || userHasRoles([Roles.ACCOUNING]);

  useEffect(() => {
    const totalAdjustment = (values?.amountToFinanceFlat ?? 0) - (values?.adjustedPayoff ?? 0);
    setFieldValue('totalAdjustment', totalAdjustment);
  }, [values?.amountToFinanceFlat, values?.adjustedPayoff]);

  const addAdjustmentFormConfig = useMemo(() => [
    {
      name: 'amountToFinanceFlat',
      label: 'Amount to Finance/Flat',
      disabled: !hasAdminAccountingRole,
      component: NumberInputField,
      allowNegative: true,
      prefix: '$',
      decimalScale: 2,
    },
    {
      name: 'adjustedPayoff',
      label: 'Adjusted Payoff',
      disabled: !hasAdminAccountingRole,
      component: NumberInputField,
      allowNegative: true,
      prefix: '$',
      decimalScale: 2,
    },
    {
      name: 'totalAdjustment',
      label: 'Total Adjustment',
      disabled: true,
      allowNegative: true,
      prefix: '$',
      decimalScale: 2,
      component: NumberInputField,
    },
  ], [hasAdminAccountingRole]);

  return (
    <>
      <FormPart config={addAdjustmentFormConfig} />
      <CommonButtonWrapper mt={2}>
        <CancelButton onClick={() => setOpenAdjustmentModal(false)} />
        <SaveButton isLoading={loading} />
      </CommonButtonWrapper>
    </>
  );
};